export const Button = ({ children, onClick, backgroundColor, color, border, 
        fontSize='16px', padding='5px 20px' }) => (
    <button
        style={{
            backgroundColor: backgroundColor,
            color: color,
            padding: padding,
            border: border,
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: fontSize,
        }}
        onClick={onClick}
    >
    {children}
    </button>
);